export default function useLayout() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    document.querySelector('.main-contents')?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return {
    scrollToTop,
  };
};
